import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) =>
  state.questionnairesDetail.loading;
export const questionnariesErrorMessage = (state: RootState) =>
  state.questionnairesDetail.error;
export const questionnairesDetailDataResponse = (state: RootState) =>
  state.questionnairesDetail.questionnairesDetailResponse;
